module.exports = __webpack_public_path__ + "static/media/footprint2.35ed2f57.png";